import LayoutPage from "../../Components/LayoutPage"
import Buttons from "./Components/Buttons"
import CouponList from "./Components/CouponsList"

export default function Coupons() {
  return (
    <LayoutPage activeIndex={8} navItems={["مدیریت کد تخفیف"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <Buttons/>
      <CouponList/>
    </LayoutPage>
  )
}